import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const NotificationContext = createContext()

const NotificationProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllNotifications = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/notification?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getSingleNotification = async (id) => {
        try {

            let { data } = await axios.get(`${baseURL}/admin/notification/${id}`, { headers })

            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const createNotification = async (notificationDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/notification/create`, notificationDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const sendNotification = async (id) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/notification/send/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateNotification = async (id, notificationDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/notification/update/${id}`, notificationDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const deleteNotification = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/admin/notification/delete/${id}`, { headers });
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <NotificationContext.Provider value={{ createNotification, sendNotification, getAllNotifications, getSingleNotification, updateNotification, deleteNotification }}>
            {children}
        </NotificationContext.Provider>
    )
}

const useNotification = () => useContext(NotificationContext)

export { useNotification, NotificationProvider }